import React, { Component } from 'react';
import { AcceptButton } from '../components/Button';
import _ from 'lodash'

import PromotionPopupTable from './components/PromotionPopupTable';
import promotionPopupStore from './stores/PromotionPopupStore';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

class ProductReportList extends Component {
  constructor(props) {
    super(props);
    this.onChangeTextDebounce = _.debounce(this.onChangeTextDebounce.bind(this), 600);
  }
  onCreateClick = () => {
    promotionPopupStore.setShowModal(true);
  }

  async onChangeTextDebounce() {
    const { getPromotionPopupCount, setTableCurrentPage, getPromotionPopupList } = promotionPopupStore;
    await getPromotionPopupCount();
    setTableCurrentPage(1);
    getPromotionPopupList();
  }

  onChangeText = async (e) => {
    const { onTextSearchChange } = promotionPopupStore;
    onTextSearchChange(e.target.value);
    this.onChangeTextDebounce();
  }
  render() {
    const { txtSearch } = toJS(promotionPopupStore);
    console.log(txtSearch)
    return (
      <div className="card">
        <div className="card-body">
          <div className='row justify-content-end' style={{ margin: 0, flex: 1, paddingRight: 16 }}>
            <AcceptButton onClick={this.onCreateClick} containerStyle={{ height: 'fit-content' }} title='Tạo mới' />
          </div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className='material-icons'>search</i>
              </span>
            </div>
            <input
              style={{ marginBottom: 12 }}
              onChange={this.onChangeText}
              type="text"
              value={txtSearch}
              className="form-control"
              placeholder="Tìm kiếm theo tên sản phẩm hoặc mã sản phẩm..." />
          </div>
          <PromotionPopupTable />
        </div>
      </div>
    )
  }

  componentDidMount() {
    promotionPopupStore.getPromotionPopupList();
    promotionPopupStore.getPromotionPopupCount();
  }
}

export default observer(ProductReportList)